module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ioDoc <= 100 && _vm.ioDoc > 75) ? _c('svg', {
    attrs: {
      "width": "30",
      "height": "30",
      "viewBox": "0 0 30 30",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0ZM15 26.5385C8.62752 26.5385 3.46154 21.3725 3.46154 15C3.46154 8.62752 8.62752 3.46154 15 3.46154C21.3725 3.46154 26.5385 8.62752 26.5385 15C26.5385 21.3725 21.3725 26.5385 15 26.5385Z",
      "fill": "#A5B948"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0ZM15 26.5385C8.62752 26.5385 3.46154 21.3725 3.46154 15C3.46154 8.62752 8.62752 3.46154 15 3.46154C21.3725 3.46154 26.5385 8.62752 26.5385 15C26.5385 21.3725 21.3725 26.5385 15 26.5385Z",
      "fill": "url(#paint0_linear)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15 25C20.5228 25 25 20.5228 25 15C25 9.47715 20.5228 5 15 5C9.47715 5 5 9.47715 5 15C5 20.5228 9.47715 25 15 25Z",
      "fill": "#A5B948"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15 25C20.5228 25 25 20.5228 25 15C25 9.47715 20.5228 5 15 5C9.47715 5 5 9.47715 5 15C5 20.5228 9.47715 25 15 25Z",
      "fill": "url(#paint1_linear)"
    }
  }), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear",
      "x1": "15",
      "y1": "0",
      "x2": "15",
      "y2": "30",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0.203125",
      "stop-color": "#52B847",
      "stop-opacity": "0.2"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "white",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear",
      "x1": "15",
      "y1": "5",
      "x2": "15",
      "y2": "25",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0.203125",
      "stop-color": "#52B847",
      "stop-opacity": "0.2"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "white",
      "stop-opacity": "0"
    }
  })], 1)], 1)]) : (_vm.ioDoc <= 75 && _vm.ioDoc > 50) ? _c('svg', {
    attrs: {
      "width": "33",
      "height": "34",
      "viewBox": "0 0 33 34",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16.5 0C7.3873 0 0 7.61116 0 17C0 26.3886 7.3873 34 16.5 34C25.6127 34 33 26.3888 33 17C33 7.61116 25.6127 0 16.5 0ZM16.5 30.0769C9.49027 30.0769 3.80769 24.2221 3.80769 17C3.80769 9.77786 9.49027 3.92308 16.5 3.92308C23.5097 3.92308 29.1923 9.77786 29.1923 17C29.1923 24.2221 23.5097 30.0769 16.5 30.0769Z",
      "fill": "#FE6904"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.5 0C7.3873 0 0 7.61116 0 17C0 26.3886 7.3873 34 16.5 34C25.6127 34 33 26.3888 33 17C33 7.61116 25.6127 0 16.5 0ZM16.5 30.0769C9.49027 30.0769 3.80769 24.2221 3.80769 17C3.80769 9.77786 9.49027 3.92308 16.5 3.92308C23.5097 3.92308 29.1923 9.77786 29.1923 17C29.1923 24.2221 23.5097 30.0769 16.5 30.0769Z",
      "fill": "url(#paint0_linear)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27 17.454C27 23.2785 22.2991 28 16.5 28C10.7009 28 6 23.2785 6 17.454C6 15.3223 6.62971 13.3385 7.71225 11.6796C9.58793 8.80598 13.662 10.0229 16.9998 12.3166C20.9723 15.0464 25.5148 12.0433 25.5148 12.0433C26.4577 13.6252 27 15.476 27 17.454Z",
      "fill": "#FE6904"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27 17.454C27 23.2785 22.2991 28 16.5 28C10.7009 28 6 23.2785 6 17.454C6 15.3223 6.62971 13.3385 7.71225 11.6796C9.58793 8.80598 13.662 10.0229 16.9998 12.3166C20.9723 15.0464 25.5148 12.0433 25.5148 12.0433C26.4577 13.6252 27 15.476 27 17.454Z",
      "fill": "url(#paint1_linear)"
    }
  }), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear",
      "x1": "16.5",
      "y1": "0",
      "x2": "16.5",
      "y2": "34",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#F8C300"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "white",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear",
      "x1": "16.5",
      "y1": "10",
      "x2": "16.5",
      "y2": "28",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#F8C300"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "white",
      "stop-opacity": "0"
    }
  })], 1)], 1)]) : (_vm.ioDoc <= 50 && _vm.ioDoc > 25) ? _c('svg', {
    attrs: {
      "width": "32",
      "height": "33",
      "viewBox": "0 0 32 33",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 0C7.16344 0 0 7.3873 0 16.5C0 25.6127 7.16344 33 16 33C24.8366 33 32 25.6127 32 16.5C32 7.3873 24.8366 0 16 0ZM16 29.1923C9.20269 29.1923 3.69231 23.5097 3.69231 16.5C3.69231 9.49027 9.20269 3.80769 16 3.80769C22.7973 3.80769 28.3077 9.49027 28.3077 16.5C28.3077 23.5097 22.7973 29.1923 16 29.1923Z",
      "fill": "#F93A2F"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 0C7.16344 0 0 7.3873 0 16.5C0 25.6127 7.16344 33 16 33C24.8366 33 32 25.6127 32 16.5C32 7.3873 24.8366 0 16 0ZM16 29.1923C9.20269 29.1923 3.69231 23.5097 3.69231 16.5C3.69231 9.49027 9.20269 3.80769 16 3.80769C22.7973 3.80769 28.3077 9.49027 28.3077 16.5C28.3077 23.5097 22.7973 29.1923 16 29.1923Z",
      "fill": "url(#paint0_linear)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27 16.1371C27 22.1366 22.0752 27 16 27C9.92479 27 5 22.1368 5 16.1371C5 14.468 7.60085 13.0048 10.0156 13C12.2241 12.9956 14.1155 14.4813 16 16.1371C20.6851 20.2535 27 16.1371 27 16.1371Z",
      "fill": "#F93A2F"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27 16.1371C27 22.1366 22.0752 27 16 27C9.92479 27 5 22.1368 5 16.1371C5 14.468 7.60085 13.0048 10.0156 13C12.2241 12.9956 14.1155 14.4813 16 16.1371C20.6851 20.2535 27 16.1371 27 16.1371Z",
      "fill": "url(#paint1_linear)"
    }
  }), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear",
      "x1": "16",
      "y1": "0",
      "x2": "16",
      "y2": "33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FE6904"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "white",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear",
      "x1": "16",
      "y1": "13",
      "x2": "16",
      "y2": "27",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FE6904"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "white",
      "stop-opacity": "0"
    }
  })], 1)], 1)]) : (_vm.ioDoc <= 25 && _vm.ioDoc > 0) ? _c('svg', {
    attrs: {
      "width": "34",
      "height": "34",
      "viewBox": "0 0 34 34",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0ZM17 30.0769C9.77786 30.0769 3.92308 24.2221 3.92308 17C3.92308 9.77786 9.77786 3.92308 17 3.92308C24.2221 3.92308 30.0769 9.77786 30.0769 17C30.0769 24.2221 24.2221 30.0769 17 30.0769Z",
      "fill": "#F93A2F"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27 22.1575C25.0321 25.6461 21.3034 28 17.0276 28C12.7647 28 9.04562 25.6602 7.07281 22.1887C6.56548 21.2958 8.79323 20.0024 11.1539 20C13.3698 19.9978 15.2956 20.9222 17.41 22.2447C22.0696 25.1587 27 22.1575 27 22.1575Z",
      "fill": "#F93A2F"
    }
  })]) : (_vm.ioDoc === 0) ? _c('svg', {
    attrs: {
      "width": "34",
      "height": "34",
      "viewBox": "0 0 34 34",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0ZM17 30.0769C9.77786 30.0769 3.92308 24.2221 3.92308 17C3.92308 9.77786 9.77786 3.92308 17 3.92308C24.2221 3.92308 30.0769 9.77786 30.0769 17C30.0769 24.2221 24.2221 30.0769 17 30.0769Z",
      "fill": "#F93A2F"
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ec3ebe1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/CircularGraphicsComponents/IOReportIcon.vue
// module id = 1684
// module chunks = 0